import React, { Component } from "react";
import { connect } from "react-redux";
import gql from "graphql-tag";
import GridItem from "../../components/Grid/GridItem.jsx";
import GridContainer from "../../components/Grid/GridContainer.jsx";
import Card from "../../components/Card/Card.jsx";
import CardHeader from "../../components/Card/CardHeader.jsx";
import CardBody from "../../components/Card/CardBody.jsx";
import OpenSelect from "../../components/select/select";
import "../../assets/css/style.css";
import CustomerTable from "./CustomerTable";
import { listVehicles } from "../../config/myqueries";
import { spinnerService } from "@chevtek/react-spinners";
import * as actionTypes from "../../redux/actions";
import { listCustomers, getCustomerVehicle } from "../../config/myqueries";
import isEmpty from 'lodash/isEqual'
class Customers extends Component {
  state = {
    vehiclesList: [],
    customersList: [],
    nextToken: undefined,
    preToken: [],
    limit: 20,
  };
  selectedItem = e => {
    this.setState({nextToken:undefined,selectedCustomer:e},()=>{
      this.loadCustomerData()
    });
  };
  async componentDidMount() {
    await this.loadCustomers();
    this.loadCustomerData();
  }
  loadCustomers = async () => {
    let { client } = this.props;
    spinnerService.show("mySpinner");
    await client.query({
      query: gql(listCustomers),
      fetchPolicy: `network-only`,
      variables: { limit: 1000 }
    }).then(res => {
      let { customersList } = this.state;
      customersList = res.data.listCustomers.items;
      this.setState({ customersList, selectedCustomer: customersList[0].id });
    }).catch(err => {
      this.setState({ customersList: [] });
    })
  }
  loadCustomerData = async () => {
    let { nextToken,selectedCustomer } = this.state;
    let { client } = this.props;
    spinnerService.show("mySpinner");
    let queryObj = {};
    if (selectedCustomer === "All") {
      queryObj = {
        query: gql(listVehicles),
        fetchPolicy: `network-only`,
        variables: { limit: 20,nextToken }
      }
    } else {
      queryObj = {
        query: gql(getCustomerVehicle),
        fetchPolicy: `network-only`,
        variables: { id:selectedCustomer, limit: 20,nextToken }
      }
    }
    await client.query(queryObj).then(res => {
      if (selectedCustomer === "All") {
        this.setState({
          vehiclesList: res.data.listVehicles.items,
          customerVehicles: res.data.listVehicles.items,
          nextToken: res.data.listVehicles.nextToken
        });
      }
      else {
        this.setState({
          vehiclesList: res.data.getCustomer.vehicles.items,
          customerVehicles: res.data.getCustomer.vehicles.items,
          nextToken:res.data.getCustomer.vehicles.nextToken
        });
      }
      spinnerService.hide("mySpinner");
    }).catch(err => {
      this.setState({ vehiclesList: [] })
      spinnerService.hide("mySpinner");
    })
  }
  nextClick = () => {
    let { nextToken, preToken, pre } = this.state;
    if (nextToken !== undefined && nextToken !== null) {
      preToken.push(nextToken);
      this.setState({ preToken, pre },()=>{
        this.loadCustomerData()
      })
    }
  }
  preClick = () => {
    let { preToken } = this.state;
    let nextToken = preToken.pop();
    nextToken = preToken.pop();
    this.setState({ nextToken },()=>{
      this.loadCustomerData()
    })
  }
  filterDriverNamesHandler(e) {
    let { customerVehicles } = this.state;
    if (!isEmpty(customerVehicles)) {
      let filteredVehicles = customerVehicles.filter(o => {
        return o.customerVehicleId.includes(e);
      });
      this.setState({ vehiclesList: filteredVehicles });
    }
  }
  render() {
    let { vehiclesList, customersList } = this.state;
    return (
      <React.Fragment>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <OpenSelect
              data={customersList}
              customer={this.state.selectedCustomer}
              selectedItem={this.selectedItem}
            />
            <Card>
              <CardHeader color="primary">
                <h4 className="cardTitleWhite">Customers Vehicles</h4>
                <p className="cardCategoryWhite">
                  Select Customer to view his/her Vehicles
              </p>
              </CardHeader>
              <CardBody style={{ minHeight: 1050 }}>
                <input
                  type="text"
                  class="form-control"
                  onChange={e => this.filterDriverNamesHandler(e.target.value)}
                  placeholder="Search Vehicle"
                  style={{ height: 35, width: 250 }}
                />
                {vehiclesList.length !== 0 ? (
                  <CustomerTable data={vehiclesList} />
                ) : (
                    <p>No Data</p>
                  )}
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
        {vehiclesList.length > 0 && <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <div >
              <span className=' fancy-a' style={{float:'left'}} ><a href="#" onClick={this.preClick}>{`<<Previous`}</a></span>
              <span style={{ float: 'left',marginTop:10 }}>|</span>
              <span className=' fancy-a' style={{float:'left'}}><a href="#" onClick={this.nextClick}>Next>></a></span>
            </div>
          </GridItem>
        </GridContainer>}
      </React.Fragment>
    );
  }
}
const mapStateToProps = state => {
  return {
    user: state.config.user,
    client: state.config.client,
    adminCustomerVehicles: state.adminCustomer.data
  };
};
const mapDispatchToProps = dispatch => {
  return {
    // addCounter: (id) => dispatch({type:actionTypes.Add_Counter, val:id}),
    storeAdminCustomerVehicles: data => dispatch(actionTypes.storeAdminCustomerVehicles(data)),
    // fetchInspection: () => dispatch(actionTypes.fetchInspection_AC()), 
  };
};
export default Customers = connect(
  mapStateToProps,
  mapDispatchToProps
)(Customers);



// WEBPACK FOOTER //
// ./src/admin/customer/Customers.jsx